module.exports = __webpack_public_path__ + "static/img/img16.3759eae6.png";